import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row, SegmentedControl, Alert } from "components/bootstrap";
import { IfPermitted, Spinner } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import CollectionMembershipConfigSection from "collections/components/CollectionMembershipConfigSection";
import ProfileSection from "./ProfileSection";
import UsersSection from "./UsersSection";
import RolesSection from "./RolesSection";
import { editableTeamSegments } from "../team-details/TeamDetails";
import LicenseCheck from "../../../license/LicenseCheck";
const TeamEdit = ({ team }) => {
  const { t } = useTranslation("enterprise_security");
  const [selectedSegment, useSelectedSegment] = useState("profile");
  if (!team) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(LicenseCheck, { featureName: "teams", displayWarningContainer: true }, ({ licenseIsValid }) => {
    if (!licenseIsValid) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
      SegmentedControl,
      {
        data: editableTeamSegments,
        value: selectedSegment,
        onChange: useSelectedSegment
      }
    )), /* @__PURE__ */ React.createElement(Col, { md: 12 }, selectedSegment === "profile" && /* @__PURE__ */ React.createElement(React.Fragment, null, !team.isSynced && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `team:edit:${team.id}` }, /* @__PURE__ */ React.createElement(ProfileSection, { team })), team.isSynced && /* @__PURE__ */ React.createElement(SectionComponent, { title: t("team_edit.synced_team_title") }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, t("team_edit.synced_team_description")))), selectedSegment === "collections" && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `team:edit:${team.id}` }, /* @__PURE__ */ React.createElement(CollectionMembershipConfigSection, { entityId: team.id, entityType: "team" })), selectedSegment === "users_roles" && /* @__PURE__ */ React.createElement(React.Fragment, null, !team.isSynced && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `team_users:edit:${team.id}` }, /* @__PURE__ */ React.createElement(UsersSection, { team })), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `team:rolesedit:${team.id}` }, /* @__PURE__ */ React.createElement(RolesSection, { team })))));
  });
};
export default TeamEdit;
